export enum ValidationStatus {
  Loading = 'Loading',
  Error = 'Error',
  Warning = 'Warning',
  Ok = 'OK',
  None = '',
}

export type FormLayout = 'horizontal' | 'vertical';
